export default "__VITE_ASSET__Dvx9Ceq6__"